import React, { useEffect, useLayoutEffect, useState } from "react";
import { Footer, Modal } from 'components/Organisms';
import { Route, Switch } from "react-router-dom";
import { GAHandler } from "./utils/GA";

import GlobalStyles from "./styles/globalStyles";
import './utils/AOS';
import {
  Home,
  Series,
  Community,
  BeCreator,
  Creators,
  Faqs,
  AnteroomSerie,
  AnteroomCommunity,
  AppRedirect,
  Redirect,
  Flixx,
  NotFound,
  Search
} from "./pages";
import {
  Header,
  Loader,
  RouteCreators,
  RoutePlay,
  ErrorBoundery
} from "./ui";
import pkgJson from '../package.json'
import { useSession, useFlags, useLocation, useModal } from "./hooks";
import { useGetMe } from "api/user";
import { isMobileOnly } from "react-device-detect";


const App = () => {

  // TODO: fix this ⬇️
  /**
   * This call is necessary for login purposes.
   * Is executed when the secret is passed through the context.
   * The hook call inside provider Session doesn't recognize the secret
   */
  useGetMe()

  const [showLoader, setShowLoader] = useState(true)

  const { isPlay, pathname } = useLocation();
  const { isCreatorsEnabled } = useFlags()
  const { isLoggedIn, user, isPreLoggedIn } = useSession();
  const { isCommunitySectionEnabled } = useFlags();
  const { Modal: ModalValidate } = useModal('validate')
  const { Modal: ModalDownloadApp } = useModal('downloadApp')


  const playRoutes = [
    {
      path: '/',
      component: Home
    }, {
      path: "/series/",
      component: Series
    }, {
      path: "/series/:serieUUID/:customSeason?/:customEpisode?",
      component: AnteroomSerie
    }, {
      path: "/community",
      component: Community,
      disabled: !isCommunitySectionEnabled
    }, {
      path: "/community/:contentUUID",
      component: AnteroomCommunity,
    }, {
      path: "/search",
      component: Search,
    }, {
      path: "/faqs",
      component: Faqs
    }, {
      path: "/flixx",
      component: Flixx
    }, {
      path: "/redirect",
      component: Redirect
    },
  ]

  const availablePlayRoutes = playRoutes.filter(route => !route.disabled)

  // TODO: Maybe this could be in Session provider...
  useEffect(() => {
    if (isPreLoggedIn && !user.status.isConfirmed) ModalValidate.open()

  }, [isLoggedIn, isPreLoggedIn])

  useEffect(() => {
    console.log(`Flixxo Web v${pkgJson.version}`)

    if (isMobileOnly && !isLoggedIn) {
      setTimeout(() => {
        ModalDownloadApp.open()
      }, 3000);
    }
  }, [])

  useLayoutEffect(() => {
    setTimeout(() => {
      setShowLoader(false)
    }, 2000);
  }, [])

  useLayoutEffect(() => {
    window.scrollTo({ top: 0 })
  }, [pathname])


  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet"/>
      <link href="https://fonts.googleapis.com/css2?family=Syne:wght@600&display=swap" rel="stylesheet"/>

        <ErrorBoundery>
          <GlobalStyles $isPlay={isPlay} />

          <Switch>

            <Route exact path='/app' component={AppRedirect}/>

            <Route exact path='/be-a-creator' component={BeCreator}/>

            {/*
              *
              * Creators routes
              *
              **/}
            {isCreatorsEnabled && (
              <Route strict path='/creators'>
                <Header />

                <Switch>
                  <RouteCreators exact path='/creators' component={Creators} />

                  <RouteCreators component={NotFound} />
                </Switch>
              </Route>
            )}

            {/*
              *
              * Play routes
              *
              **/}
            <Route exact path={availablePlayRoutes.map(item => item.path)}>
              <Header />
              {showLoader && <Loader />}

              { availablePlayRoutes.map(({ path, component }) => (
                <RoutePlay exact key={path} path={path} component={component} />
              ))}
            </Route>
            <RoutePlay component={NotFound} />

          </Switch>

          {isPlay && <Footer />}

          <Modal/>
        </ErrorBoundery>
    </>
  );
};
 
export default App
